import { createAxios } from '../../lib/axiosFactory';
import { dataCollectionParser } from '../../lib/response/dataParser';
import { errorParser } from '../../lib/response/errorParser';
import { VuexLocalStorage } from '../../lib/vuexLocalStorage';
import { Client } from '../../lib/interfaces/client';
import { ActionResponse } from '../../lib/interfaces/actionResponse';
import { Pages } from '../../lib/enums/pages';

const storage = new VuexLocalStorage('_ADMIN_CLIENT_');

export const state = {
  clients: [] as Client[],
  totalCount: null as number | null,
  totalSubscribedCount: null as number | null,
  prevPages: [],
  currentPage: {},
  nextPages: []
};

export const mutations = {
  setClients(state: any, clients: any[]): void {
    state.clients = clients;
  },

  setClient(state: any, client: any): void {
    const clientIndex = state.clients.findIndex((x: any) => x.id === client.id);
    if (clientIndex !== -1) {
      state.clients[clientIndex] = client;
    }
  },

  setTotalCount(state: any, count: number): void {
    state.totalCount = count;
  },

  setPages(state: any, pageLinks: any): void {
    state.prevPages = pageLinks.previousPages;
    state.currentPage = pageLinks.currentPage;
    state.nextPages = pageLinks.nextPages;
  }
};

export const getters = {};

export const actions = {
  async loadClients(
    { commit, rootState },
    {
      endpoint,
      searchCriteria
    }: { endpoint?: string; searchCriteria?: Record<string, any> } = {}
  ): Promise<void> {
    try {
      let response;

      if (endpoint) {
        response = await createAxios().get(endpoint);
      } else {
        response = await createAxios().get(
          '/backend/mobiz-admin-clients-index',
          {
            params: {
              'page[limit]': rootState.user.pageSizes[Pages.AdminClients] || 25,
              ...searchCriteria
            }
          }
        );
      }

      const { links, meta } = response.data;
      commit('setClients', dataCollectionParser(response));
      commit('setTotalCount', meta.totalRecords);
      commit('setPages', links);
    } catch (error) {
      commit('setClients', []);
    }
  },

  async updateClient(context: any, { payload }: any): Promise<ActionResponse> {
    try {
      const response: any = await createAxios().patch(
        '/backend/mobiz-admin-clients-update',
        {
          data: {
            type: 'clients',
            attributes: payload
          }
        }
      );

      const responseClientData: any = response.data.data;
      const updatedAttributes = responseClientData.attributes;
      const updatedClients = context.state.clients.map((client: Client) => {
        if (client.id === responseClientData.id) {
          client = { ...client, ...updatedAttributes };
        }
        return client;
      });

      return { body: responseClientData, success: true, errors: {} };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error
      };
    }
  },

  async getClient(
    { commit, rootState },
    clientId: string
  ): Promise<ActionResponse> {
    try {
      const response = await createAxios().get(
        '/backend/mobiz-admin-clients-show',
        {
          params: {
            clientId
          }
        }
      );

      return {
        body: response.data.data.attributes.attributes,
        success: true,
        errors: {}
      };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error
      };
    }
  }
};
